<template>
    <div id="example">
        <h1 class="text-center pt-5" :id="name" v-if="state">
            <a :href="`#collapseCards` + category_id" data-toggle="collapse" style="margin-top: 0;">
                <span
                    style="background-color: #968147; color: #fff; padding: 10px 20px; border-radius: 50px; font-weight: bold;">
                    {{ name }}
                </span>
            </a>
        </h1>
        <div :class="isFirstCategory ? `collapse.show` : `collapse`" v-for="(product, index) in products" :key="index"
            :id="`collapseCards` + category_id" class="text-center" v-show="product.status">
            <br>
            <div class="list2 accordion" :value="product.id" id="accordionCard">
                <div class="row justify-content-md-center">
                    <a :href="`#collapse` + index + category_id" data-toggle="collapse">
                        <h3 class="col col-md-auto" style="padding: 10px 0; font-weight: bold; color: #535353;">
                            {{ product.name }}
                        </h3>
                    </a>
                </div>
                <div class="row align-items-center collapse" data-parent="#accordionCard"
                    :id="`collapse` + index + category_id">
                    <div class="col-lg-4 col-md-12" style="margin-bottom: 3%;">
                        <img :src="base_url + '/uploads/' + product.image" alt="">
                    </div>
                    <div class="col-lg-5 col-md-12">
                        <P v-html="product.description"></P>
                    </div>

                    <div class="card-list col-lg-3 col-md-12">
                        <div class="card-item-zero"></div>
                        <div class="card-item-price">
                            <div style="padding: 10px 0;">
                                <span style="font-size: 24px;">{{ product.price }}</span>
                                <span>元</span>
                            </div>
                        </div>
                        <div class="card-item-add">
                            <button class="button" style="flex:1 1;" v-on:click="addcart(product.id)"><i
                                    class="fas fa-shopping-cart"></i>&nbsp;&nbsp;加入購物車</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" ref="exampleModalCenter" role="dialog" aria-labelledby="exampleModalCenterTitle"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalCenterTitle">填寫購買資料</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div v-for="(item, index) in list" :key="index">
                                <cart-field v-if="item.type == 'text'" :field="item" v-model="information[item.name]">
                                </cart-field>
                                <div v-if="item.type == 'checkbox'">
                                    <label for="formGroupExampleInput">{{ item.name }}</label>
                                    <div>
                                        <div class="form-check form-check-inline" v-for="(values, index) in item.values"
                                            :key="index">
                                            <input type="checkbox" class="form-check-input" v-bind:id="values"
                                                v-model="information[item.name]" :value="values"
                                                :disabled="information[item.name].length >= item.count && information[item.name].indexOf(values) == -1">
                                            <label class="form-check-label" v-bind:for="values">{{ values }}</label>
                                        </div>
                                    </div><br>
                                </div>
                                <div v-if="item.type == 'radio'">
                                    <label for="formGroupExampleInput">{{ item.name }}</label>
                                    <div>
                                        <div class="form-check form-check-inline" v-for="(values, index) in item.values"
                                            :key="index">
                                            <input type="radio" class="form-check-input" v-bind:id="values"
                                                v-model="information[item.name]" :value="values">
                                            <label class="form-check-label" v-bind:for="values">{{ values }}</label>
                                        </div>
                                    </div><br>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">取消</button>
                        <button type="submit" class="btn btn-primary" v-on:click="addtocart">加入購物車</button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="deep">
            <gen :text="item.name" v-for="(item, index) in children" :key="index"></gen>

        </div>
</div>
</template>

<script>
import eventHub from '../library/eventHub';
import ApiBase from './components/ApiBase';
export default {
    extends: ApiBase,
    props: {
        text: {
            default: 0
        },
        deep: {
            default: false
        }

    },
    data() {
        return {
            category_id: '',
            products: '',
            base_url,
            list: [],
            quantity: 1,
            information: {},
            children: [],
            name: '',
            state: true,
            isFirstCategory: false,
        }
    },
    methods: {
        getctproducts: function (id) {
            axios
                .get(base_url + '/api/category/' + id + '/products')
                .then((response) => {
                    this.products = response.data.products;
                    let category_data = this.products.map(function (p) {
                        return p.category;
                    });
                    category_data.map(c => c.parent_id)[0] ? this.isFirstCategory = false : this.isFirstCategory = true;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        addcart: function (id) {
            this.dataIsLoading(true);
            this.category_id = id;
            axios
                .get(base_url + '/api/products/' + id)
                .then((response) => {
                    this.list = response.data.fields;
                    this.information = {};
                    for (var i = 0; i < this.list.length; i++) {
                        this.$set(this.information, this.list[i].name, "")
                        if (this.list[i].type == "checkbox")
                            this.$set(this.information, this.list[i].name, [])
                    }
                    this.dataIsLoading(false);
                })
                .catch(function (error) {
                    console.log(error);
                });
            $(this.$refs.exampleModalCenter).modal('show');
        },
        addtocart: function () {
            let datckecked = true;
            for (var i = 0; i < this.list.length; i++) {
                if (this.list[i].required == false)
                    continue
                if (this.list[i].type == "checkbox") {
                    if (this.information[this.list[i].name].length != this.list[i].count) {
                        datckecked = false;
                        this.$swal(this.list[i].name + '至少選取' + this.list[i].count + '個')
                    }
                }
                else if (this.list[i].type == "text") {
                    if (this.information[this.list[i].name] == "") {
                        datckecked = false;
                        this.$swal({
                            title: this.list[i].name + '欄位至少填一個',
                            confirmButtonColor: 'rgb(144 103 103)',
                        })
                    }
                }
            }
            if (datckecked == false) {
                return
            }
            axios
                .post(base_url + '/api/cart/add', {
                    product_id: this.category_id,
                    quantity: this.quantity,
                    information: this.information,
                })
                .then((response) => {
                    this.$swal({
                        icon: 'success',
                        title: '購物車',
                        text: '成功加入購物車',
                        showConfirmButton: false,
                        timer: 1500
                    });

                    $(this.$refs.exampleModalCenter).modal('hide');
                    eventHub.$emit('cart:update', response.data)
                })
                .catch((error) => {
                    let error_response;
                    if (error.isAxiosError) error_response = error.response;
                    else return;
                    if (error_response.status === 422 && error_response.data.message === 'payload is too long.') {
                        $(this.$refs.exampleModalCenter).modal('hide');
                        this.$swal({
                            icon: 'error',
                            title: '商品已達上限',
                            text: '此訂單可選購商品已達上限，請先結帳後，再繼續選購。'
                        });
                    }
                    // console.log(error_response);
                });
        },
        getCategories: function () {
            axios
                .get(base_url + '/api/category/' + this.text)
                .then((response) => {
                    this.children = response.data.children;
                    this.name = response.data.name;
                    this.state = response.data.state;
                    this.category_id = response.data.id;
                    eventHub.$emit('categoryupdate', this.name);
                    this.getctproducts(this.category_id);

                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        getAllCategories: function () {
            axios
                .get(base_url + '/api/category/' + 0)
                .then((response) => {
                    eventHub.$emit('allcategory', response.data);
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
    },
    created() {
        this.getCategories()
        this.getAllCategories()
    },
}
</script>
<style scoped>
/* #summary {
        font-size: 14px;
        line-height: 1.5;
    }

    #summary p.collapse:not(.show) {
        overflow: hidden;

        display: -webkit-box;
        -webkit-line-clamp: 6;
        -webkit-box-orient: vertical;
    }

    #summary a.collapsed:after {
        content: "更多內容";
    }

    #summary a:not(.collapsed):after {
        content: "收起內容";
    } */

.button {
    background-color: #B19C83;
    color: #f9f9f9;
    border: 2px solid #B19C83;
    padding: 10px 5px;
    text-align: center;
    transition-duration: 0.4s;
    cursor: pointer;
    border-radius: 50px;
    font-weight: bold;
    font-size: 20px;
}

.button:hover {
    background-color: #7A8473;
    border: 2px solid #7A8473;
}

@media(max-width:991px) {
    .button {
        padding: 10px;
    }
}

.list2 {
    border-radius: 10px;
    background: #FFEEE8;
    padding: 10px 20px;
    /* width: 70%; */
    /* position: relative; */
    /* left: 50%; */
    /* transform: translate(-50%, -0%); */
}

@media(max-width:991px) {
    .list2 {
        display: block;
    }
}


.card-list {
    display: flex;
    flex-grow: 1;
}

@media (min-width: 640px) {
    .card-list {
        flex-direction: column;
        text-align: center;
    }
}

.card-item-zero {
    flex-grow: 2;
}

@media(max-width:991px) {
    .card-item-zero {
        flex-grow: 0;
    }
}

.card-item-price {
    flex-grow: 2;
}

.card-item-add {
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    flex-shrink: 0;
}

.modal-footer {
    justify-content: space-between !important;
}
</style>
